/**
 * @fileoverview The user-invitations feature's one shared mock adapter.
 * @description Every mock endpoint in this feature registers on this single MockAdapter instance —
 * axios-mock-adapter installs itself by overwriting the Axios instance's defaults.adapter, so a
 * second `new MockAdapter(httpClient)` in this feature would silently replace this one. Requests no
 * handler matches pass through (to the previously installed adapters, then the network). Null
 * when VITE_ENABLE_MOCK_API is false.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import MockAdapter from 'axios-mock-adapter'

import { appConfig } from '@/config/app-config'
import { httpClient } from '@/shared/api/http-client'

export const userInvitationsMockAdapter = appConfig.enableMockApi
  ? new MockAdapter(httpClient, { delayResponse: 500, onNoMatch: 'passthrough' })
  : null
